module.exports = __webpack_public_path__ + "d99b0f4dd380617dade47600b186f505.fbx";